 
 
import { useState, useEffect } from 'react'; 
 
export default function BlockSpace({ block, updateBlock }) {
    const [space, setSpace] = useState(block.height);

    useEffect(() => {  
        
    
       document.getElementById(`space-${block.id}`).style.height = space;
        
    }, [space]);

    function handleSpaceChange(e){
        setSpace(e.target.value);
        block.height = e.target.value;
    }

 
    return (
        <div>
            <label className="block font-semibold mb-2">Espaçamento:</label>
            
            <select className="w-full p-2 border border-gray-300 rounded" onChange={handleSpaceChange}>
                <option value="20px">Pequeno</option>
                <option value="50px">Médio</option>
                <option value="100px">Grande</option>
            </select>

            <label className="block font-semibold mb-2">Personalizado:</label>
            
            <input
                type="range"
                min="5"
                max="200"
                value={parseInt(space) || 50}
                onChange={e => {
                    const pxValue = `${e.target.value}px`;
                    setSpace(pxValue);
                    block.height = pxValue;
                }}
                className="w-full"
            />
          
                 
             
        </div>
    );
}
